import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material"
import PaperDraggable from "../../../../../components/PaperDraggable"
import { IDataPesquisarCafe } from "../../../../../types/api/cafe/pesquisar-lotes-cafe"
import InfoHeader from "../../../../../components/DialogComponents/InfoHeader"
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import { IDataDatalharLoteCafe } from "../../../../../types/api/cafe/detalhar-lote-cafe";
import InfoSection from "../../../../../components/DialogComponents/InfoSection";
import tratativaDeDatas from "../../../../../helpers/tratativaDeDatas";
import InfoSectionTable from "../../../../../components/DialogComponents/InfoSectionTable";
import { formatarNumero } from "../../../../../helpers/masks";

export default function DetalheLote({
    open,
    value,
    handleClose
}: DetalheLoteProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["dialog-detalhar-lote-cafe", value],
        queryFn: () => axiosClient.get("/detalhar-lote-cafe/", {
            params: {
                codigo_publico: value.codigo_publico,
                fazenda_id: value.fazenda_id,
                grao_id: value.grao_id,
                meeeiro: value.meeeiro,
                numero_lote: value.numero_lote,
                tipo_publico: value.tipo_publico,
            }
        }),
        cacheTime: 0
    });
    const detalheLote: IDataDatalharLoteCafe = data?.data || null
    //

    //funções manipuladoras
    const handleVerificarPeneiras = (obj: string) => {
        const formatObj: { [key: string]: number } = JSON.parse(obj)

        const result = Object.keys(formatObj).reduce((acc: any, key) => {
            if (formatObj[key] > 0) {
                acc[key] = `${key}:${formatObj[key]}`;
            }
            return acc;
        }, []);
        const arrComPrefixo = result.filter((item: any)=> item !== null).map((item: any) =>{ 
                const [pen, percentual] = item.split(':');
                return `${pen} = ${percentual.slice(0,2)},${percentual.slice(2,3) || '0'}%`
    }).join(' / ')
        return arrComPrefixo
    }
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth="md"
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Detalhes do lote
            </DialogTitle>

            <DialogContent>

                <InfoHeader>
                    <Box display="flex" alignItems="center" gap={4}>
                        <Typography variant="caption" fontWeight="bold">
                            {value.numero_lote}
                        </Typography>
                        <Typography
                            variant="caption"
                            fontWeight="bold"
                        >
                            {`${value.safra_inicial}/${value.safra_final}`}
                        </Typography>
                    </Box>

                    <Typography variant="caption" fontWeight="bold">
                        {`${value.tipo_publico}${value.codigo_publico} - ${value.nome_publico}`}
                    </Typography>
                </InfoHeader>

                {
                    isLoading &&
                    <LoadingApiQuery />
                }

                {
                    (!isLoading && detalheLote) &&
                    <Grid container spacing={2} mt={1}>
                        <Grid
                            container
                            size={{xs: 12, md: 5}}
                            spacing={1}
                            alignSelf="flex-start"
                        >
                            <Grid size={{xs: 12}}>
                                <InfoSection
                                    titulo="Informações do documento"
                                    items={[
                                        {
                                            section: [
                                                { label: "Data do documento", valor: tratativaDeDatas(detalheLote.data_documento) },
                                                { label: "Nº do documento", valor: detalheLote.numero_documento },
                                                { label: "Série", valor: detalheLote.serie_documento || "-" },
                                                { label: "Filial", valor: detalheLote.nome_filial || "-" },
                                                { label: "Fazenda", valor: detalheLote.nome_fazenda || "-" },
                                            ]
                                        }
                                    ]}
                                />
                            </Grid>

                            <Grid size={{xs: 12}}>
                                <InfoSection
                                    titulo="Informações de localização"
                                    items={[
                                        {
                                            section: [
                                                { label: "Prateleira", valor: detalheLote.prateleira ?? "-" },
                                                { label: "Andar", valor: detalheLote.andar ?? "-" },
                                                { label: "Quadro", valor: detalheLote.quadro ?? "-" },
                                                { label: "Nº da pilha", valor: detalheLote.pilha_numero || "-" },
                                                { label: "Sequência da pilha", valor: detalheLote.pilha_sequencia || "-" },
                                                { label: "Ponteiro", valor: detalheLote.ponteiro || "-" },
                                            ],
                                        },
                                        {
                                            section: [
                                                { label: "Bloco", valor: detalheLote.bag_bloco ?? "-" },
                                                { label: "Filial", valor: detalheLote.bag_filial ?? "-" },
                                                { label: "Armazém", valor: detalheLote.bag_armazem || "-" },
                                                { label: "Quadra", valor: detalheLote.bag_quadra ?? "-" },
                                                { label: "Sequência da bag", valor: detalheLote.bag_sequencia ?? "-" },
                                            ],
                                        },
                                    ]}
                                />
                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, md: 7}} spacing={1}>
                            <Grid size={{xs: 12}}>
                                <InfoSection
                                    titulo="Detalhes"
                                    items={[
                                        {
                                            section: [
                                                { label: "Lote zerado", valor: detalheLote.lote_zerado === "S" ? "Sim" : "Não" },
                                                { label: "Negociando", valor: detalheLote.negociado_descricao ?? "-" },
                                                { label: "Documento entrada", valor: detalheLote.documento_entrada ?? "-" },
                                                { label: "Data de classificação", valor: tratativaDeDatas(detalheLote.data_classificacao) },
                                                { label: "Peso", valor: detalheLote.peso ?? "-" },
                                                { label: "Peso médio", valor: detalheLote.peso_medio ?? "-" },
                                                { label: "Sacas", valor: detalheLote.prateleira ?? "-" },
                                                { label: "Padrão", valor: detalheLote.padrao ?? "-" },
                                                { label: "Tipo de grão", valor: detalheLote.grao_tipo_nome || "-" },
                                                { label: "Cor", valor: detalheLote.grao_cor_nome || "-" },
                                                { label: "Bebida", valor: detalheLote.grao_bebida_nome || "-" },
                                                { label: "Aspecto", valor: detalheLote.grao_aspecto_nome || "-" },
                                                { label: "Umidade", valor: `${formatarNumero(detalheLote.secagem)}%` ?? "-" },
                                                { label: "Fava", valor: detalheLote.fava || "-" },
                                                { label: "Peneiras", valor: handleVerificarPeneiras(detalheLote.peneiras) || "-" },
                                                { label: "Catação", valor: `${formatarNumero(detalheLote.catacao)}%` ?? "-" },
                                                { label: "Impureza", valor: `${formatarNumero(detalheLote.impureza)}%` ?? "-" },
                                                { label: "Renda", valor: detalheLote.renda ?? "-" },
                                                { label: "Escolha", valor: detalheLote.escolha ?? "-" },
                                                { label: "Observação", valor: detalheLote.observacao || "-" },
                                            ],
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <InfoSectionTable
                                titulo="Movimentos do lote"
                                cabecalho={[
                                    { label: "Documento", prop: "documento" },
                                    { label: "Data", prop: "data" },
                                    { label: "Tipo Movimentação", prop: "tipoMov" },
                                    { label: "Sacas", prop: "sacas", align: "right" },
                                    { label: "Peso", prop: "peso", align: "right" },
                                ]}
                                data={detalheLote.movimentacoes.map((item) => {
                                    return ({
                                        documento: `${item.numero_documento} - ${item.serie_documento}`,
                                        data: tratativaDeDatas(item.data_movimentacao),
                                        tipoMov: item.nome_movimentacao,
                                        sacas: formatarNumero(item.sacas),
                                        peso: formatarNumero(item.peso),
                                    })
                                })}
                            />
                        </Grid>
                    </Grid>
                }

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DetalheLoteProps {
    open: boolean,
    handleClose: () => void
    value: IDataPesquisarCafe
}

//